import React, { useMemo } from "react"
import ConversationsBrandSelector from "../conversations-brand-selector"
import SearchInput from "../form/search-input"
import List from "./list"
import ConversationFilter from "../conversation-filter"
import { useSelector } from "react-redux"
import {
  currentFilter,
  searchQuery as searchQueryStored,
  setSearchQuery
} from "../../../redux/slices/conversations"
import { FilterID, FilterIDs, Threads } from "../../../types"
import { initialMsgNotReplied } from "../../utils"
import { useAppDispatch, useAppSelector } from "../../hooks"

interface Props {
  threads: Threads
  isLoading: boolean
}

const ConversationsList = ({ threads, isLoading }: Props) => {
  const dispatch = useAppDispatch()

  const searchQuery = useAppSelector(searchQueryStored)

  const currentConversationFilter = useSelector(currentFilter)

  const handleSearchQueryChange = (value: string) => {
    dispatch(setSearchQuery(value))
  }

  // TODO: move this to useConversations
  const filteredThreads = useMemo(() => {
    const filterByStatusAndEvents = (
      filters: FilterIDs,
      threadsToFilter: typeof threads
    ) => {
      return threadsToFilter?.filter(thread => {
        const isNotReplied = initialMsgNotReplied(thread)

        return (
          (filters.includes(thread.status as FilterID) ||
            thread.events.some(event =>
              filters.includes(event.type as FilterID)
            ) ||
            (isNotReplied && filters.includes("not_replied")) ||
            (!isNotReplied && filters.includes("replied"))) ??
          []
        )
      })
    }

    let filtered = threads || []

    if (searchQuery.trim() !== "") {
      const lowercasedQuery = searchQuery.toLowerCase()
      filtered = filtered.filter(
        thread =>
          `${thread.first_name} ${thread.last_name}`
            .toLowerCase()
            .includes(lowercasedQuery) ||
          thread.email.toLowerCase().includes(lowercasedQuery) ||
          thread.phone.includes(lowercasedQuery)
      )
    }

    if (currentConversationFilter && currentConversationFilter.length) {
      filtered =
        filterByStatusAndEvents(currentConversationFilter, filtered) ?? []
    }

    return filtered
  }, [searchQuery, threads, currentConversationFilter])

  //if (error) return <div>Error loading threads</div>

  return (
    <div className="w-screen sm:w-[367px] min-w-full sm:min-w-[367px] sm:max-w-[367px] bg-white border-r border-neutral-200 overflow-y-auto">
      <div className="p-4 sticky top-0 bg-white border-b border-neutral-200 z-10">
        <div className="flex items-center gap-3">
          <SearchInput
            disabled={isLoading}
            className="py-2"
            wrapperClassName="w-full"
            placeholder="Search Leads"
            value={searchQuery}
            onSearch={val => handleSearchQueryChange(val as string)}
          />
          <ConversationFilter />
        </div>
        <ConversationsBrandSelector />
      </div>

      <List isLoading={isLoading} filteredThreads={filteredThreads} />
    </div>
  )
}

export default ConversationsList
